module.exports = __webpack_public_path__ + "static/media/arrow_down.e0ba4f3e.svg";